export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES_EN_BLANK.50bc64cb.png";